"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.beefyfinance = void 0;
exports.beefyfinance = {
    oldTimelock: '0x8f0fFc8C7FC3157697Bdbf94B328F7141d6B41de',
    strategyOwner: '0x65CF7E8C0d431f59787D07Fa1A9f8725bbC33F7E',
    vaultOwner: '0xA2E6391486670D2f1519461bcc915E4818aD1c9a',
    keeper: '0x340465d9D2EbDE78F15a3870884757584F97aBB4',
    rewarder: '0xd529b1894491a0a26B18939274ae8ede93E81dbA',
    treasurer: '0x7C780b8A63eE9B7d0F985E8a922Be38a1F7B2141',
    launchpoolOwner: '0x362704FC0e43Ad29963331AC986645ff6b0e8552',
    devMultisig: '0x44b74ED902e6423B51Bd9e44B6e5646749376943',
    rewardPool: '0x453D4Ba9a2D594314DF88564248497F7D74d6b2C',
    treasury: '0x4A32De8c248533C28904b24B4cFCFE18E9F2ad01',
    beefyFeeRecipient: '0xEB41298BA4Ea3865c33bDE8f60eC414421050d53',
    gasPrice: '0x16cD932c494Ac1B3452d6C8453fB7665aB49EC6b',
    multicall: '0xB94858b0bB5437498F5453A16039337e5Fdc269C',
    bifiMaxiStrategy: '0x87056F5E8Dce0fD71605E6E291C6a3B53cbc3818',
};
